import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './LogisticWorkItem';
import SelectApprovers from './SelectApprovers';
import Step4 from './Step4';
import axios from 'axios';

const LogisticCreate = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [step, setStep] = useState(1);
  const [vendorsList, setVendorsList] = useState([]);

  const storedUser = JSON.parse(localStorage.getItem("user")) || {};

  const [rfq, setRfq] = useState({
    logisticDraftId: "",
    modeOfConsignment: "",
    consignee: "",
    invoiceNo: "",
    transitTime: "",
    address: "",
    noOfPallets: "",
    grossWeight: "",
    length: "",
    breadth: "",
    height: "",
    volumeCBM: "",
    currency: [],
    origin: "",
    destination: "",
    submissionDate: ""
  });

  const [items, setItems] = useState([
    { srNo: 1, particulars: "", quantity: "", unit: "", currency: "", newRate: 0, exchangeRate: 0, total: 0, itemOrder: "" }
  ]);

  const [approvers, setApprovers] = useState({
    purchaseHead: "",
    awardee1: "",
    awardee2: ""
  });
  const [selectVendors, setSelectVendors] = useState([]);

  useEffect(() => {
    const getVendors = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/vendor-org/vendors?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setVendorsList(res.data);
      } catch (error) {
        console.log("Failed to fetch vendors:", error);
      }
    };
    getVendors();
  }, []);

  useEffect(() => {
    if (!id) {
      setStep(1);
      setRfq({
        logisticDraftId: "",
        modeOfConsignment: "",
        consignee: "",
        invoiceNo: "",
        transitTime: "",
        address: "",
        noOfPallets: "",
        grossWeight: "",
        length: "",
        breadth: "",
        height: "",
        volumeCBM: "",
        currency: [],
        origin: "",
        destination: "",
        submissionDate: ""
      });
      setItems([{ srNo: 1, particulars: "", quantity: "", unit: "", currency: "", newRate: 0, exchangeRate: 0, total: 0 }]);
      setSelectVendors([]);
    }
  }, [id]);

  return (
    <div className="App">
      <center>
        <h2 className="form-title">
          {id ? `Edit Logistic RFQ #${id}` : "Create New Logistic RFQ"}
        </h2>
      </center>

      <div className="progress-container" style={{ margin: '20px auto', width: '90%' }}>
        <div
          className="blue-bar"
          style={{ width: `${(step / 5) * 100}%`, height: '100%', transition: '0.3s' }}
        ></div>
      </div>

      <div className="dashboard-container">
        {step === 1 && (
          <Step1 rfq={rfq} setRfq={setRfq} setStep={setStep} />
        )}
        {step === 2 && (
          <Step2 rfq={rfq} setRfq={setRfq} setStep={setStep} />
        )}
        {step === 3 && (
          <Step3
            rfq={rfq}
            setStep={setStep}
            items={items}
            setItems={setItems}
            onFinish={() => setStep(4)}
          />
        )}
        {step === 4 && (
          <SelectApprovers
            approvers={approvers}
            setApprovers={setApprovers}
            selectVendors={selectVendors}
            setSelectVendors={setSelectVendors}
            storedUser={storedUser}
            setStep={setStep}
          />
        )}
        {step === 5 && (
          <Step4
            rfq={{
              ...rfq,
              selectedVendors: vendorsList.filter(v => selectVendors.includes(v.email))
            }}
            items={items}
            approvers={approvers}
            selectVendors={selectVendors}
            setStep={setStep}
          />
        )}
      </div>
    </div>
  );
};

export default LogisticCreate;